import { Button } from "./ui/button";
import { X, Check, Ban, Sparkles, Wrench } from "lucide-react";

// Sticky bulk workflow-review bar shared across pages that support multi-select
// review with a shared note (Worklist, Error Detail, ...).
export function BulkReviewBar({ count, note, setNote, onAction, onClear, pending }) {
  if (!count) return null;
  return (
    <div
      data-testid="bulk-action-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 backdrop-blur px-6 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.15)]"
    >
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center gap-3">
        <span className="text-sm font-semibold shrink-0" data-testid="bulk-selected-count">
          {count} selected
        </span>
        <input
          type="text"
          data-testid="bulk-note-input"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Add a workflow note (optional) — applied to all selected"
          maxLength={1000}
          disabled={pending}
          className="order-last w-full min-w-[10rem] md:order-none md:w-72 rounded-md border border-border bg-background px-3 h-9 text-sm outline-none focus:border-foreground/40"
        />
        <div className="ml-auto flex flex-wrap items-center gap-2">
          <Button variant="outline" size="sm" data-testid="bulk-clear" onClick={onClear} disabled={pending}>
            <X size={15} className="mr-1" /> Clear
          </Button>
          <Button variant="outline" size="sm" data-testid="bulk-acknowledge" onClick={() => onAction("ACKNOWLEDGED")} disabled={pending}>
            <Check size={15} className="mr-1" /> Acknowledge
          </Button>
          <Button variant="outline" size="sm" data-testid="bulk-explain" onClick={() => onAction("EXPLAINED")} disabled={pending}>
            <Sparkles size={15} className="mr-1" /> Explain
          </Button>
          <Button variant="outline" size="sm" data-testid="bulk-correct" onClick={() => onAction("CORRECTED")} disabled={pending}>
            <Wrench size={15} className="mr-1" /> Correct
          </Button>
          <Button size="sm" data-testid="bulk-dismiss" onClick={() => onAction("DISMISSED")} disabled={pending}>
            <Ban size={15} className="mr-1" /> Dismiss
          </Button>
        </div>
      </div>
    </div>
  );
}
